import { createStyles } from '@material-ui/core';

export default createStyles({
    pickerView: {
        marginTop: '0.8rem',
        minWidth: '28.0rem',
        minHeight: '28.0rem',
    },
});
